export default __webpack_public_path__ + "static/media/Ramen Lockup_Horizontal-FullColour.bcd896a1.svg";